import React from "react";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { useReveal } from "../hooks/useReveal";
import { services } from "../mock";
import { toast } from "../hooks/use-toast";

const ServiceCard = ({ service, index }) => {
  const { lang, t } = useLang();
  const [ref, visible] = useReveal({ threshold: 0.1 });
  const Icon = service.icon;
  const data = service[lang];

  return (
    <div
      ref={ref}
      className={`reveal ${visible ? "is-visible" : ""} service-card group bg-white rounded-2xl overflow-hidden border border-zinc-100 shadow-[0_10px_30px_-18px_rgba(20,24,31,.25)]`}
      style={{ transitionDelay: `${(index % 3) * 90}ms` }}
    >
      <div className="relative h-44 overflow-hidden">
        <img src={service.image} alt={data.title} className="service-img w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />
        <div className="absolute top-4 left-4 h-11 w-11 rounded-xl grid place-items-center bg-white/95 backdrop-blur shadow-md">
          <Icon className="h-5 w-5" style={{ color: "var(--zd-red)" }} />
        </div>
      </div>
      <div className="p-6">
        <h3 className={`font-display font-bold text-lg leading-snug ${lang === "zh" ? "font-zh" : ""}`} style={{ color: "var(--zd-ink)" }}>{data.title}</h3>
        <p className={`mt-2 text-sm leading-relaxed ${lang === "zh" ? "font-zh" : ""}`} style={{ color: "var(--zd-slate)" }}>{data.desc}</p>
        <button
          onClick={() => toast({ title: data.title, description: lang === "zh" ? "请通过下方表单联系我们了解详情。" : "Contáctanos con el formulario para más información." })}
          className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold group-hover:gap-2.5 transition-all"
          style={{ color: "var(--zd-red)" }}
        >
          {t.services.cta} <ArrowUpRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

const Services = () => {
  const { t, lang } = useLang();
  const [ref, visible] = useReveal();

  return (
    <section id="servicios" className="py-20 md:py-28 bg-zinc-50">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div ref={ref} className={`reveal ${visible ? "is-visible" : ""} text-center max-w-2xl mx-auto`}>
          <span className={`text-sm font-bold uppercase tracking-wider ${lang === "zh" ? "font-zh" : ""}`} style={{ color: "var(--zd-red)" }}>{t.services.tag}</span>
          <h2 className={`font-display font-bold text-3xl md:text-4xl mt-3 ${lang === "zh" ? "font-zh" : ""}`} style={{ color: "var(--zd-ink)" }}>{t.services.title}</h2>
          <div className="h-1 w-16 mx-auto mt-4 rounded-full" style={{ background: "var(--zd-gold)" }} />
          <p className={`mt-4 ${lang === "zh" ? "font-zh" : ""}`} style={{ color: "var(--zd-slate)" }}>{t.services.subtitle}</p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {services.map((s, i) => <ServiceCard key={s.id} service={s} index={i} />)}
        </div>
      </div>
    </section>
  );
};

export default Services;
